import { render, staticRenderFns } from "./nguidanceList.vue?vue&type=template&id=c6f2ae3c&scoped=true&"
import script from "./nguidanceList.vue?vue&type=script&lang=js&"
export * from "./nguidanceList.vue?vue&type=script&lang=js&"
import style0 from "./nguidanceList.vue?vue&type=style&index=0&id=c6f2ae3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f2ae3c",
  null
  
)

export default component.exports